import React from 'react';

const IntroBoxText = ({ title, para, className }) => {
    return (
        <div className={ `inner-box customAnim ${className}` }>
            <div className="intro-box p-18">
                <h1 className="heading has-line left-line">{ title }</h1>
                <div dangerouslySetInnerHTML={ { __html: para } } />
            </div>
        </div>
    );
};

export default IntroBoxText;